import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";

export const ResponsableSelectID = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  useEffect(() => {
    request
      .get("GenerarConvenioModal/DropDownListResponsables")
      .then((result) => {
        // Agregar la opción de "Consolidado" con id 0
        const responsablesOptions = [
          { value: 0, label: "Consolidado" }, 
          ...result.map((responsable) => ({
            value: responsable.idusuario,
            label: responsable.responsable_cobranza,
          })),
        ];
        setState(responsablesOptions);
      })
      .catch((error) => {
        console.error("Error obteniendo responsables:", error);
      });
  }, []);

  return (
    <select className="select-responsable" name={name} value={value} onChange={onChange}>
      {state.map((item) => (
        <option key={`responsable-${item.value}`} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};
